import styled, { css } from "styled-components";

export const _DesignViewContainer = styled.main`
  flex-direction: column;
  display: flex;
  justify-content: space-evenly;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

// Desktop only: on mobile the preview scrolls away and PreviewBar takes over,
// so nothing changes document height in response to scrolling.
const stickySection = css`
  @media (min-width: 768px) {
    position: sticky;
    align-self: flex-start;
    top: 100px;
    z-index: 1;
  }
`;

export const _LayoutSectionDesignView = styled.div`
  position: relative;

  @media (min-width: 768px) {
    width: 45%;
    flex-basis: 50%;
    padding-left: 15px;
    
    &:last-of-type {
      border-left: 1px solid lightgrey;
      padding-left: 30px;
    }
  }

  ${(props) => props.sticky && stickySection}
`;
